import React, { Component } from 'react';
import PropTypes from 'prop-types';

import LocalitzacioDetallMapa from '../commons/localitzacioDetallMapa';
import { textQuanNoHiHaDada } from '../../constants';

class EstacioDetallLocalitzacio extends Component {

    hiHanCoordenades(localitzacio) {
        if (!localitzacio) return false;
        if (!localitzacio.latitud) return false;
        if (!localitzacio.longitud) return false;
        return true;
    }

    obtenirValorAmbUnitat(valor, unitat) {
        if (isNaN(Number.parseFloat(valor))) return textQuanNoHiHaDada;
        return valor + unitat;
    }

    render() {
        const { localitzacio } = this.props;
        if (!this.hiHanCoordenades(localitzacio)) {
            return <div></div>;
        }

        const { latitud, longitud, altitud } = localitzacio;
        let coordenades = { latitud, longitud };

        return (
            <div className='estacio-detall-localitzacio'>

                <div>
                    <div><span>Latitud: </span>{this.obtenirValorAmbUnitat(latitud, '°')}</div>
                    <div><span>Longitud: </span>{this.obtenirValorAmbUnitat(longitud, '°')}</div>
                    <div><span>Altitud: </span>{this.obtenirValorAmbUnitat(altitud, ' m')}</div>
                </div>

                {/* Aquest div addicional cal per tal que el div del mapa tingui el width assignat pel CSS Grid. */}
                <div><LocalitzacioDetallMapa coordenades={coordenades} classeCss='localitzacio-detall-mapa' /></div>

            </div>
        );
    }
}

EstacioDetallLocalitzacio.propTypes = {
    localitzacio: PropTypes.object
};

export default EstacioDetallLocalitzacio;



// WEBPACK FOOTER //
// ./src/components/estacio/estacioDetallLocalitzacio.js